import { InformationCircleIcon } from "@heroicons/react/20/solid";
import "./App.css";
import { master } from "./master";
import ReactGA from "react-ga4";

// import "@fontsource/public-sans";
import "@fontsource/roboto/300.css";
import "@fontsource/roboto/400.css";
import "@fontsource/roboto/500.css";
import "@fontsource/roboto/700.css";

import { Controls } from "./controls";

ReactGA.initialize("G-WYMLYH9X57");

export function App() {
  return (
    <div className="bg-white">
      <Heading />
      <Controls master={master} />
    </div>
  );
}

function gaClick(label: string) {
  ReactGA.event({
    category: "Interval Trainer",
    action: "Click",
    label: label,
    value: 1,
  });
}

function Heading() {
  return (
    <div className=" px-6 pt-8 sm:pt-16 lg:px-8">
      <div className="mx-auto max-w-2xl text-center">
        <h2 className="text-4xl font-bold tracking-tight text-gray-900 sm:text-6xl">
          EQ Ear Trainer
        </h2>
        <p className="mt-6 text-lg leading-8 text-gray-600">
          Improve your ear training skills for mixing with the EQ Ear Training tool. This
          interactive tool helps you identify frequency boosts and cuts.
        </p>
        <div className="flex mt-6 max-w-md m-auto p-4 bg-gray-50 rounded text-gray-500">
          <InformationCircleIcon className="w-10" aria-hidden="true" />
          <p className="text-xs">
            For full frequency range, use quality headphones/speakers; computer speakers may not replicate lowest frequencies.
          </p>
        </div>
      </div>
    </div>
  );
}